import { Input } from "reactstrap";
import { NameAndPhoneNumber } from "../../../../../Utils/Constants";
import SvgIcon from "../../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import FeatherIcons from "../../../../../Utils/CommonComponents/CommonIcons/FeatherIcons";

const SearchContacts = () => {
  return (
    <div className="search-contacts">
      <Input type="text" placeholder={NameAndPhoneNumber}/>
      <SvgIcon iconId="stroke-search" />
      <FeatherIcons iconName="Mic" className="feather feather-mic mic-search" />
    </div>
  );
};

export default SearchContacts;
